import LazyComponent from "../../controls/LazyComponent";
import settingsReducer from "./reducers";
function init(context) {
    context.registerReducer(["settings", "metaserver"], settingsReducer);
    context.registerSettings("Download", LazyComponent(() => require("./SettingsMetaserver")));
    return true;
}
export default init;
